/**
 * The geometry of scrubbing a кружочек by its ring.
 *
 * An enlarged note is seekable by a knob that rides its round progress ring,
 * and the one real computation in that gesture — where around the circle a
 * finger is — lives here rather than in MediaBubbles, for the same reason the
 * viewer's zoom maths lives in zoom.ts: an arctangent wants a unit test, and a
 * unit test wants no DOM.
 *
 * The convention is the ring's own: 0 at twelve o'clock, growing clockwise to
 * 1. That is the direction a conic gradient fills by default, so a fraction
 * from here multiplies straight into the arc's percentage and the knob's
 * rotation without either side converting anything.
 */

export interface Point {
  x: number;
  y: number;
}

/**
 * Where around the ring a pointer is, as a fraction of the way round.
 *
 * Screen coordinates, so y grows downward — which is why the upward axis is
 * `-dy`. Only the angle matters: a finger is never exactly on a hairline arc,
 * and holding the knob anywhere while circling the centre at whatever radius
 * is the whole reason the gesture is comfortable. The centre itself answers 0
 * rather than NaN; a pointer event that lands there is one pixel of noise, not
 * a case worth surfacing.
 */
export function ringFraction(center: Point, point: Point): number {
  const dx = point.x - center.x;
  const dy = point.y - center.y;
  if (dx === 0 && dy === 0) return 0;
  // Clockwise from twelve o'clock: the x offset leads and up is negative y,
  // which turns atan2's usual counter-clockwise-from-east into what the ring
  // draws.
  const turn = Math.atan2(dx, -dy) / (2 * Math.PI);
  return (turn + 1) % 1;
}
